/** Optional user/device context refining which viewer route applies. */

/** Returns the base viewer route path based on environment and optional user/device context.
 *  Uses `/viewer-v2/` when an iframe URL is configured, the deployment is not on-premise,
 *  the new viewer is enabled, and the device is not mobile; falls back to
 *  `/viewer/quredicom/` otherwise. */
export function getViewerRoute(options) {
  var _options$showNewViewe, _options$isMobile;
  var hasIframeUrl = Boolean(process.env.NEXT_PUBLIC_VIEWER_IFRAME_URL);
  var isOnpremise = process.env.NEXT_PUBLIC_IS_ONPREMISE === "true";
  var showNewViewer = (_options$showNewViewe = options === null || options === void 0 ? void 0 : options.showNewViewer) !== null && _options$showNewViewe !== void 0 ? _options$showNewViewe : true;
  var isMobile = (_options$isMobile = options === null || options === void 0 ? void 0 : options.isMobile) !== null && _options$isMobile !== void 0 ? _options$isMobile : false;
  if (showNewViewer && hasIframeUrl && !isMobile && !isOnpremise) {
    return "/viewer-v2/";
  }
  return "/viewer/quredicom/";
}